import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'smm-label',
  imports: [TranslatePipe, NgOptimizedImage],
  template: `
    <div class="flex align-items-center gap-1">
      <label
        class="input__label"
        [class]="isNewsletter() ? 'newsletter__label highlight__Standard' : ''"
        [for]="id()"
      >
        {{ labelName() | translate }}
        <span class="text-red-200">{{ required() ? '*' : '' }}</span>
        <span>
          <span class=" optional text-neutral-400">{{
            isOptional() ? ' (' + ('BUTTONS.OPTIONAL' | translate) + ') ' : ''
          }}</span>
        </span>
      </label>
      @if (labelIcon()) {
        <img [ngSrc]="labelIcon()" width="20" height="20" alt="" />
      }
    </div>
  `,
  styles: [
    `
      .text-red-200 {
        color: #d00416;
      }
      .text-neutral-400 {
        color: #9ca3af;
      }
      .newsletter__label {
        color: #fcfcfc;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Label {
  labelName = input.required<string>();
  required = input(false);
  isOptional = input(false);
  labelIcon = input<string>('');
  isNewsletter = input(false);
  id = input<string>('');
}
